import React, { Component } from "react"
import PropTypes from "prop-types"
import Stack from "@kit/design/stack"
import { Label } from "./label"

const randomId = name =>
  `field-${name}-${Math.random().toString(36).substring(2, 7)}`

export class Field extends Component {
  static propTypes = {
    id: PropTypes.string,
    control: PropTypes.any,
    children: PropTypes.node,
    className: PropTypes.string,
    label: PropTypes.string,
    note: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string.isRequired,
    span: PropTypes.number,
    controlClassName: PropTypes.string
  }

  static defaultProps = {
    span: 12
  }

  constructor(props) {
    super(props)
    this.id = props.id || randomId(props.name)
  }

  render() {
    const {
      id,
      label,
      children,
      className,
      control,
      span,
      controlClassName,
      note,
      ...props
    } = this.props
    const Control = control

    return (
      <Stack spacing={1} className={className}>
        {label && <Label htmlFor={this.id}>{label}</Label>}
        {note && <div className="text-gray-700 text-sm pt-1 pb-2">{note}</div>}
        {Control && (
          <Control id={this.id} className={controlClassName} {...props} />
        )}
        {children}
      </Stack>
    )
  }
}
